import React, { FC } from 'react';
import { Box } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

type InvoiceCertificationStatusProps = {
    lineItemWithOrderCount: number;
    certifiedOrderCount: number;
};
const InvoiceCertificationStatus: FC<InvoiceCertificationStatusProps> = ({
    lineItemWithOrderCount,
    certifiedOrderCount,
}: InvoiceCertificationStatusProps) => {
    const condition = lineItemWithOrderCount === certifiedOrderCount;
    const Icon = condition ? CheckCircleIcon : CircleIcon;
    const color = condition ? 'success.main' : 'grey.700';

    return (
        <Box sx={{ color: color }} display="flex" alignItems="center">
            <Icon fontSize="small" />{' '}
            <Box ml={1}>
                {certifiedOrderCount} / {lineItemWithOrderCount}
            </Box>
        </Box>
    );
};

export default InvoiceCertificationStatus;
